import Vue from 'vue';

export default {
    props: {
        content: String,
    },
    template: '<div ref="summary"></div>',
    mounted: function () {
        var CompileSummary = Vue.extend({
            data: function () {
                return {
                    showPPO:false,
                    addMargin: false
                }
            },
            created: function(){
                if(ibJS.section) {
                    this.addMargin = true;
                }
            },
            template: `<div :class="addMargin ? 'c-Plan-details__text--add-margin' : ''" class="c-Plan-details__text pponetwork-content-js-index c-Plan-list__content-para">
                        ${this.content}</div>`,
            methods: {
                showModal: function (url) {
                    // had to use global because regular emit was not working for this
                    global.eventHub.$emit('showModalFromSummary', url);
                },
                showMiddlePageModal () {
                    global.eventHub.$emit('showMiddlePageModal');
                }
            }
        });

        new CompileSummary().$mount(this.$refs['summary']);
    }
};
